<template>
  <div>
    <!-- type="0" :route="route"  -->
    <Header title="审核" :casLogin="casLogin"></Header>
    <div class="stop-item">
      <div style="width:100%;">
        <van-cell-group>
          <van-field
            v-if="schoolCode == '10013' && seqtype != '0'"
            v-model="shyj"
            label="上一级审核意见"
            type="textarea"
            input-align="right"
            autosize
            readonly
          />
          <van-field
            v-if="isShowFile || shyjData.fileurl"
            v-model="fj"
            type="textarea"
            autosize
            input-align="right"
            label="附件"
            readonly
          />
          <van-field
            v-model="spjg"
            label="审核意见"
            placeholder="请点击选择"
            readonly
            is-link
            @click="showPicker1 = true"
            input-align="right"
          />
          <van-field
            v-show="(seqtype == '0' && cjxmFlag) || seqtype == '2'"
            v-model="cjxmtext"
            label="成绩项目"
            placeholder="请点击选择"
            readonly
            :disabled="seqtype == '2'"
            is-link
            @click="
              seqtype == '2' ? (showPicker3 = false) : (showPicker3 = true)
            "
            input-align="right"
          />
          <van-field
            v-show="(seqtype == '0' && fszFlag) || seqtype == '2'"
            v-model="newCode"
            label="成绩修改为"
            placeholder=""
            @change="checkNb()"
            input-align="right"
            :readonly="sh_step != '1'"
            :disabled="seqtype == '2'"
          />
          <van-field
            v-show="
              (seqtype == '0' && djzFlag) || (seqtype == '2' && oldcjfs != 'D')
            "
            v-model="newCode_dj"
            label="成绩修改为"
            placeholder="请点击选择"
            readonly
            :disabled="seqtype == '2'"
            is-link
            @click="
              sh_step == '1'
                ? (showPicker_code = true)
                : (showPicker_code = false)
            "
            input-align="right"
          />
          <van-field
            v-model="person"
            v-if="shr_flag == '1' && (spjgId == '1' && oldcjfs != '')"
            label="下一步审核人"
            placeholder="请点击选择"
            readonly
            is-link
            @click="peoplePop = true"
            input-align="right"
          />
          <van-field
            class="xx"
            v-show="seqtype == '0' || spjgId == '0'"
            v-model="remark"
            label="审核依据"
            :placeholder="remark_y"
            input-align="right"
          />
          <van-field
            style="display:none"
            label="备注"
            placeholder="非必填"
            input-align="right"
          />
        </van-cell-group>
      </div>
      <div v-if="isShowFile || shyjData.fileurl">
        <van-button class="bottom-button" type="default" @click="CheckFile"
          >查看附件</van-button
        >
        <van-button class="bottom-button1" type="default" @click="pushExamine"
          >审核</van-button
        >
      </div>
      <div v-else>
        <van-button class="bottom-button2" type="default" @click="pushExamine"
          >审核</van-button
        >
      </div>
      <van-popup v-model="showPicker1" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns1"
          @confirm="onConfirm1"
          :item-height="35"
          @cancel="showPicker1 = false"
        />
      </van-popup>
      <van-popup v-model="showPicker3" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnscjxm"
          @confirm="onConfirm3"
          :item-height="35"
          @cancel="showPicker3 = false"
        />
      </van-popup>
      <van-popup v-model="peoplePop" position="bottom">
        <div class="apply-pop">
          <div class="pop-title">
            <i class="closeIcon" @click="peoplePop = false"></i>
            <p>审核人</p>
            <i class="conIcon" @click="resetCancel()"></i>
          </div>
          <div class="person">
            <button
              class="per-btn"
              ref="person"
              @click="personTap($event, index)"
              v-for="(item, index) in personList"
              :key="item.id"
            >
              {{ item.name }}
            </button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showPicker_code" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns_code"
          @confirm="onConfirm_code"
          :item-height="35"
          @cancel="showPicker_code = false"
        />
      </van-popup>
      <van-popup v-model="show" id="reImg"></van-popup>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import tApi from "../../../../utils/teacher";
import Vue from "vue";
import { Popup, Toast } from "vant";

Vue.use(Popup);
export default {
  data() {
    return {
      casLogin: sessionStorage.getItem("casLogin"),
      route: this.$route.params.route,
      remark: "",
      remark_y: "请填写修改成绩的原因",
      shyj: "",
      fj: "",
      spjg: "",
      spjgId: "1",
      shr: "",
      shrId: "",
      columns1: [
        { text: "通过，需要修改成绩", value: "1" },
        { text: "不通过，无需修改成绩", value: "0" }
      ],
      showPicker1: false,
      peoplePop: false,
      shr_list: [],
      uploader: [],
      route_params: {},
      personList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      isShowFile: false,
      person: "",
      personId: "",
      route_tk: {},
      shr_flag: false,
      reset: "",
      resetId: "",
      ywinstanceid: "",
      isEndShow: "",
      image: "",
      show: false,
      img: {},
      img1: {},
      shyjData: {},
      schoolCode: sessionStorage.getItem("schoolCode"),
      fszFlag: false,
      djzFlag: false,
      newCode_dj: "",
      newCode: "",
      oldcjfs: "",
      showPicker_code: false,
      columns_code: [],
      sh_step: "",
      seqtype: "", // seqtype 0 第一步审核,1 中间步骤,2 最后一步审核
      ywcode: "",
      cjxmtext: "",
      cjxmid: "",
      columnscjxm: [],
      showPicker3: false,
      cjxmFlag: false,
      isCanSh:true
    };
  },
  watch: {
    spjgId: {
      handler(n) {
        if (n == "1") {
          if (this.oldcjfs != "") {
            this.remark_y = "请填写修改成绩的原因";
          } else {
            this.remark = "审核通过";
          }
        }
        if (n == "0") {
          if (this.oldcjfs != "") {
            this.remark_y = "请填写无需修改成绩的原因";
          } else {
            this.remark = "审核不通过";
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.route_tk = JSON.parse(decodeURI(this.$route.params.route_params));
    this.getList();
  },
  methods: {
    onOversize(file) {
      this.$toast.fail("文件大小不能超过2M");
    },
    CheckFile() {
      localStorage.setItem("shyjData", JSON.stringify(this.shyjData));
      let type = this.fj.substring(
        this.fj.lastIndexOf(".") + 1,
        this.fj.length
      );
      if (
        type.indexOf("xsl") !== -1 ||
        type.indexOf("xslx") !== -1 ||
        type.indexOf("xls") !== -1
      ) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (type.indexOf("docx") !== -1) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (type.indexOf("pdf") !== -1) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (
        type.indexOf("jpg") !== -1 ||
        type.indexOf("png") !== -1 ||
        type.indexOf("jpeg") !== -1
      ) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else {
        Toast("抱歉!当前文件不支持预览");
      }
    },
    resetCancel() {
      this.peoplePop = false;
      this.person = this.reset;
      this.personId = this.resetId;
    },
    reImage() {
      this.show = true;
      this.$nextTick(() => {
        if (this.img.width >= 320) {
          this.img.style.width = "320px";
        } else {
          this.img.style.width = "auto";
        }
        document.getElementById("reImg").appendChild(this.img);
      });
    },
    async getList() {
      const params = {
        id: this.route_tk.id_sh
      };
      const sh = await tApi.querySybShyj(params);
      if (sh.data !== null) {
        this.shyj = sh.data.shyj ? sh.data.shyj : "无";
        this.fj = sh.data.qzwffilename ? sh.data.qzwffilename : "无";
        this.shyjData = sh.data;
      }
      const res = await Api.getshXx(params);
      if (res.code == "0") {
        this.$toast.fail(res.Msg);
        this.isCanSh = false;
        return;
      }
      this.ywcode = res.qzwfexample.ywcode;
      this.seqtype = res.seqtype;
      this.cjxmid = res.selectCjxm;
      if (res.cjxmList.length > 0) {
        res.cjxmList.forEach((item, index) => {
          if (item.cj0712id == this.cjxmid) {
            this.cjxmtext = item.cjxmmc;
          }
          this.columnscjxm[index] = { text: item.cjxmmc, value: item.cj0712id };
        });
      }
      if (res.iscjsh_firstStep && res.iscjsh_firstStep == "1") {
        this.sh_step = res.sh_seq;
        if (this.seqtype == "0") {
          this.columns1 = [
            { text: "通过，需要修改成绩", value: "1" },
            { text: "不通过，无需修改成绩", value: "0" }
          ];
          this.spjg = "通过，需要修改成绩";
        } else {
          this.columns1 = [
            { text: "通过", value: "1" },
            { text: "不通过", value: "0" }
          ];
          this.spjg = "通过";
        }
        this.oldcjfs = res.iscjsh_firstStep_cjMess.cjfs;
        if (this.spjgId == "1") {
          this.remark_y = "请填写修改成绩的原因";
          if (res.iscjsh_firstStep_cjMess.cjfs == "D") {
            this.fszFlag = true;
            this.cjxmFlag = true;
            this.djzFlag = false;
            this.newCode = !res.modifyVale ? "" : res.modifyVale;
          } else {
            this.djzFlag = true;
            this.fszFlag = false;
            this.cjxmFlag = false;
            for (
              let i = 0;
              i < res.iscjsh_firstStep_cjMess.djfsContextList.length;
              i++
            ) {
              this.columns_code.push({
                text: res.iscjsh_firstStep_cjMess.djfsContextList[i].djfsmc,
                value: res.iscjsh_firstStep_cjMess.djfsContextList[i].dm
              });
            }
            this.newCode_dj = !res.modifyVale ? "" : res.modifyVale;
          }
        } else {
          this.remark_y = "请填写无需修改成绩的原因";
        }
      }
      this.shr_flag = res.xsxyb;
      let concatList = [];
      if (res.nextRoleList && res.nextRoleList.length > 0) {
        res.nextRoleList.forEach((item, index) => {
          concatList[index] = {
            name: item.userrealname,
            id: item.userid,
            isBtn: 0
          };
        });
      }
      this.isEndShow = res.qzwfdefine.isend;
      this.ywinstanceid = res.qzwfexample.ywinstanceid;
      this.personList = this.personList.concat(concatList);
      if (res.recList.length == 0) {
        this.isShowFile = false;
      } else {
        this.isShowFile = true;
      }

      const ret = await Api.downfile({
        tkid: this.route_tk.ywinstanceid
      });
      if (ret.type == "application/json") {
        let span = document.createElement("span");
        span.innerText = "无";
        // document.getElementById("myMain").appendChild(span);
        return;
      }
      let blob = new Blob([ret], {
        type: ["image/png", "image/jpeg", "image/gif"]
      });
      this.img = document.createElement("img");
      this.img1 = document.createElement("img");
      let url = window.URL.createObjectURL(blob);
      this.img.src = url;
      this.img.onload = function() {
        window.URL.revokeObjectURL(url);
      };
      this.img1.src = url;
      this.img1.onload = function() {
        window.URL.revokeObjectURL(url);
      };
      this.img1.style.width = "80px";
      this.img1.style.height = "80px";
      // document.getElementById("myMain").appendChild(this.img1);
    },
    async afterRead(file) {
      let formData = new FormData();
      formData.append("ywinstanceid", this.route_tk.xq_id || this.ywinstanceid);
      formData.append("id", this.route_tk.id_sh);
      formData.append("file", file.file);
      const res = await Api.fileUpload(formData);
      this.$toast(res.Msg);
    },
    async pushExamine() {
      console.log("-------isCan-------",this.isCanSh);
      if(!this.isCanSh){
        return;
      }
      if (this.shr_flag == "1" && this.spjgId == "1" && !this.person) {
        this.$toast("请选择下一步审核人");
        return;
      }
      if (
        this.sh_step == "1" &&
        this.spjgId == "1" &&
        (this.newCode == "" && this.newCode_dj == "")
      ) {
        this.$toast("修改后的成绩不能为空！");
        return;
      }
      if ((this.seqtype == "0" || this.spjgId == "0") && this.remark == "") {
        this.$toast("审核依据不能为空！");
        return;
      }
      if (this.schoolCode == "10013" && !Boolean(this.cjxmtext)) {
        this.$toast("成绩项目不能为空！");
        return;
      }
      let remark_temp = this.remark;
      if(remark_temp==''){
        remark_temp = "审核通过";
      }
      const params = {
        id: this.route_tk.id_sh,
        type: this.spjgId,
        shyj: remark_temp,
        code: this.route_tk.sh_flag,
        oldcjfs: this.oldcjfs,
        newCode_dj: this.newCode_dj,
        newCode: this.newCode,
        cjxmid: this.cjxmid
      };
      if (this.shr_flag == "1") {
        params.userids = this.personId;
      }
      if(params.userids == null || params.userids == ''){
        let userids_temp = "";
        for(let i=0;i<this.personList.length;i++){
          if(this.personList[i].id!=""){
            if(i==this.personList.length-1){
              userids_temp +=this.personList[i].id;
            }else{
              userids_temp +=this.personList[i].id+",";
            }
          }
        }
        params.userids = userids_temp;
      }
      let res = {};
      if (this.route_tk.new) {
        res = await Api.workflowAuditingNew(params);
      } else {
        res = await Api.workflowAuditing(params);
      }
      if (res.code == "1") {
        this.$toast.success("审核成功");
        setTimeout(() => {
          this.$router.replace("/new/Home_10013");
        }, 2000);
        //this.$router.push({
          //path: "/teacher/examine/examineCommomSuccess",
          //query: { params: this.route_tk }
       // });
      } else {
        this.isCanSh = false;
        this.$toast(res.Msg);
        setTimeout(() => {
          if (!!this.route_tk.route) {
            this.$router.replace(this.route_tk.route);
          } else {
            this.$router.replace("/teacher/examineIndex");
          }
        }, 2000);
      }
    },
    onConfirm1(value) {
      this.spjg = value.text;
      this.spjgId = value.value;
      this.showPicker1 = false;
      if (this.oldcjfs != "") {
        if (this.spjgId != "1") {
          this.fszFlag = false;
          this.cjxmFlag = false;
          this.djzFlag = false;
        } else {
          if (this.oldcjfs == "D") {
            this.fszFlag = true;
            this.cjxmFlag = true;
            this.djzFlag = false;
          } else {
            this.djzFlag = true;
            this.fszFlag = false;
            this.cjxmFlag = false;
          }
        }
      }
    },
    onConfirm3(value) {
      this.cjxmtext = value.text;
      this.cjxmid = value.value;
      this.showPicker3 = false;
    },
    onConfirm_code(value) {
      this.newCode_dj = value.text;
      this.showPicker_code = false;
    },
    onConfirm2(value) {
      this.shr = value.text;
      this.shrId = value.value;
      this.showPicker2 = false;
    },
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.personList[res].isBtn == 0) {
        this.personList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.personList[res].isBtn == 1) {
        this.personList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.personList) {
        if (this.personList[res].name == "全部") {
          this.personList[i].isBtn = 0;
          this.personList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.personList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.personList[i].isBtn == 1) {
          strList = strList.concat(this.personList[i].name);
          idList = idList.concat(this.personList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    checkNb() {
      if (this.newCode != "") {
        this.newCode = this.newCode.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        this.newCode = this.newCode.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        this.newCode = this.newCode
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".");
        this.newCode = this.newCode.replace(
          /^(\-)*(\d+)\.(\d\d).*$/,
          "$1$2.$3"
        ); //只能输入两个小数
        if (this.newCode.indexOf(".") < 0 && this.newCode != "") {
          //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
          this.newCode = parseFloat(this.newCode);
        }
        if (parseFloat(this.newCode) > 100) {
          this.newCode = "";
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.stop-item {
  width: 100%;
  display: flex;
  justify-content: center;
}
.bottom-button,
.bottom-button1,
.bottom-button2 {
  font-size: 16px;
  font-weight: 600;
  height: 44px;
  line-height: 44px;
  position: absolute;
  bottom: 20px;
  border-radius: 3px;
}
.bottom-button {
  width: calc(~"50% - 30px");
  left: 20px;
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.bottom-button1 {
  width: calc(~"50% - 30px");
  right: 20px;
  background-color: @attendance-background-color-1;
  color: white;
}
.bottom-button2 {
  left: 20px;
  width: calc(~"100% - 40px");
  background-color: @attendance-background-color-1;
  color: white;
}
.center input::placeholder {
  color: @attendance-background-color-2;
  font-weight: 0 !important;
}
/deep/ .van-field__control {
  color: @attendance-color-1 !important;
  font-weight: 600;
}
/deep/ .van-cell {
  font-size: 16px;
}
/deep/.van-field__label {
  width: 120px;
}
/deep/ .van-picker__cancel {
  color: rgba(0, 0, 0, 0);
}
/deep/ .van-picker__confirm {
  color: rgba(0, 0, 0, 0);
}
.xx {
  /deep/ .van-field__body {
    padding-right: 6px;
  }
  /deep/ .van-field__label {
    width: 72px;
  }
}
.upload-line {
  /deep/ .van-field__label {
    width: 75px;
  }
}
/deep/ .van-cell {
  padding: 20px 16px 10px 20px;
}
/deep/ .van-cell:not(:last-child)::after {
  left: 20px;
  right: 20px;
}
/deep/ .van-cell__right-icon {
  margin-left: 3px;
  color: @attendance-background-color-2;
}
/deep/ .van-picker-column {
  position: relative;
}
/deep/ .van-picker-column::before {
  width: 140px !important;
  height: 1px !important;
  background-color: @attendance-background-color-2!important;
  content: "" !important;
  position: absolute !important;
  top: 70px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  border-bottom: none !important;
  border-top: none !important;
}
/deep/ .van-picker-column::after {
  width: 140px;
  height: 1px;
  background-color: @attendance-background-color-2;
  content: "";
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
}
/deep/
  .van-ellipsis
  /deep/
  .van-picker-column__item
  /deep/
  .van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}

.stop-item .closeIcon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.stop-item .conIcon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.stop-item .pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.stop-item .pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  border-radius: 5px 5px 0 0;
}
.stop-item .person {
  padding: 57px 15px 15px 15px;
}
.stop-item .person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}
.stop-item .apply-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.stop-item .person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
.stop-item
  /deep/.van-popup
  /deep/.van-popup--bottom
  /deep/.van-picker
  /deep/.van-picker-column {
  position: relative;
}
.stop-item
  /deep/.van-ellipsis
  /deep/.van-picker-column__item
  /deep/.van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}
#reImg {
  background-color: transparent;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Examine/commom/index_cj_setoOne.vue